import { useContext } from 'react';
import Upload from 'src/components/Attachments/Upload';
import Section from 'src/components/util/Section';
import FormContext from 'src/contexts/appeal-context';
import { Button } from '@mui/material';

const SCHEDULE_B_FORM_URL = 'https://assessor.utahcounty.gov/assessor/documents/schedule-b.pdf';

export default function Attachments() {
  const { formData } = useContext(FormContext);

  return (
    <Section title="Schedule B File Upload">
      <p className="font-medium">
        You only need to upload a Schedule B if you have never filed your personal property taxes
        for this year. If you already submitted a Schedule B with a late personal property tax
        filing, you do not need to upload it again here.
      </p>
      <p>
        To complete a late filing, download the{' '}
        <a
          className="font-medium text-blue-600 hover:underline dark:text-blue-500"
          href={SCHEDULE_B_FORM_URL}
          rel="noreferrer"
          target="_blank"
        >
          Schedule B form
        </a>{' '}
        and list every piece of equipment used in your business. For each item, include the year it
        was acquired, a description of the item, and its cost.
      </p>
      <p>
        Include equipment even if it was originally purchased for personal use. Once an item is used
        in the business, it must be reported as business personal property.
      </p>
      <p>Sign and date the completed form, then save it and upload it below.</p>

      <div className="flex-start">
        <Button href={SCHEDULE_B_FORM_URL} rel="noreferrer" target="_blank" variant="contained">
          Download Schedule B Form
        </Button>
      </div>

      <div className="flex flex-col gap-1">
        Schedule B <i>Max 2 files (4MB each)</i>
        <Upload files={formData.scheduleB} title="scheduleB" />
      </div>
    </Section>
  );
}
